import type { CommonRefundMethodSetting } from '@link/admin/services';

export const PAGE_SIZE = 20;

export const SELECT_PAGE_SIZE = 100;

export const LOGIN_PATH = '/login';

export const Scope = {
  Link: 'link',
  Merchant: 'merchant',
  Shop: 'shop'
} as const;

export type Scope = (typeof Scope)[keyof typeof Scope];

export const Role = {
  Link: 'link',
  MerchantAdmin: 'merchantAdmin',
  MerchantStaff: 'merchantStaff',
  ShopAdmin: 'shopAdmin',
  ShopStaff: 'shopStaff'
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const ROLE_SCOPE: Record<Role, Scope> = {
  [Role.Link]: Scope.Link,
  [Role.MerchantAdmin]: Scope.Merchant,
  [Role.MerchantStaff]: Scope.Merchant,
  [Role.ShopAdmin]: Scope.Shop,
  [Role.ShopStaff]: Scope.Shop
};

export const ROLE_HOME: Record<Role, string> = {
  [Role.Link]: '/link/dashboard',
  [Role.MerchantAdmin]: '/merchant/dashboard',
  [Role.MerchantStaff]: '/merchant/dashboard',
  [Role.ShopAdmin]: '/shop/dashboard',
  [Role.ShopStaff]: '/shop/dashboard'
};

export const LINK_MERCHANT_ID = 'link';
export const LINK_MERCHANT_NAME = 'リンクティビティ';

export const STAFF_MANAGER_ROLES: Role[] = [
  Role.Link,
  Role.MerchantAdmin,
  Role.ShopAdmin
];

export const REFUND_METHOD_RATES = [
  { name: 'wechatRate', key: 'wechatRateE2' },
  { name: 'alipayRate', key: 'alipayRateE2' },
  { name: 'creditRate', key: 'creditRateE2' },
  { name: 'unionRate', key: 'unionRateE2' },
  { name: 'cashRate', key: 'cashRateE2' }
] as const satisfies {
  name: string;
  key: keyof CommonRefundMethodSetting;
}[];
